import { defineMessage } from 'react-intl';

/**
 * Shared labels for connection identity when a platform has no real user profile.
 */
export const connectionIdentityMessages = {
  /** Fallback label when a CMS-style connection has no custom name. */
  defaultConnectionName: defineMessage({
    id: 'socialExport.connections.defaultConnectionName',
    defaultMessage: 'Default',
  }),
};
